import React from 'react';
import {A11y, Navigation} from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Card } from 'react-bootstrap';
import RutinasData from '../../../data/rutinas';

function Rutinas() {
  return (
    <div className='container' style={{ marginTop: '20px' }}>
      <h1
        style={{
          textAlign: 'center',
          textTransform: 'uppercase',
            fontFamily: 'Anton-Regular',
            marginBottom: '2rem'
        }}>
        Rutinas de Entrenamiento
      </h1>
        <Swiper
            // install Swiper modules
            modules={[Navigation]}
            spaceBetween={30}
            slidesPerView={4}
            navigation
            pagination={{ clickable: true }}
            scrollbar={{ draggable: true }}
            loop="true"
            css-mode="true"
            breakpoints={{
                // when window width is >= 640px
                200: {
                    slidesPerView: 2,
                },
                // when window width is >= 768px
                768: {
                    slidesPerView: 4,
                },
            }}
        >
            {RutinasData.map((rutina,index) =>
                <SwiperSlide>
                    <a href={rutina.url} target={"_blank"} style={{width:"inherit"}}><img src={rutina.img} alt="" key={index} style={{width:"inherit"}}/></a>
                </SwiperSlide>
            )}
        </Swiper>
    </div>
  );
}

export default Rutinas;
